import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CreateOrder from "../../../components/Modal/Admin/OrderManagement/CreateOrder";
import EditOrder from "../../../components/Modal/Admin/OrderManagement/EditOrder";
import ViewOrder from "../../../components/Modal/Admin/OrderManagement/ViewOrder";
import axiosInstance from "../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Oval } from "react-loader-spinner";

export default function ManageOrder() {
  const [orders, setOrders] = useState([]);
  const [show, setShow] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState("");
  const [pagination, setPagination] = useState({});
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [apiSuccess, setApiSuccess] = useState(null);
  const MySwal = withReactContent(Swal);

  const storedPermissions = localStorage.getItem("userPermissions");
  const userDataString = localStorage.getItem("userData");
  let userTypeId = null;

  if (userDataString) {
    const userData = JSON.parse(userDataString);
    userTypeId = userData.user.user_type_id;
  } else {
    console.log("No user data found");
  }

  const permissions = storedPermissions ? JSON.parse(storedPermissions) : [];


  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      try {
        const orderResponse = await axiosInstance.get("/user/order/fetch", {
          params: {
            page,
            filter,
          },
        });

        const fetchedOrders = orderResponse.data.data.orders.data;

        // Group orders by order_code and sum total_price and quantity
        const groupedOrders = fetchedOrders.reduce((acc, order) => {
          const key = order.order_code; // Unique key based on order_code
          if (!acc[key]) {
            acc[key] = {
              ...order,
              sum_total_price: 0, // Initialize sum_total_price
              sum_quantity: 0,
            };
          }
          // Sum total_price and quantity for all payment types
          acc[key].sum_total_price += order.total_price;
          acc[key].sum_quantity += order.quantity;

          return acc;
        }, {});

        const ordersArray = Object.values(groupedOrders).sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );

        setOrders(ordersArray);

        // Convert groupedOrders object back to array
        
        // const ordersArray = Object.values(groupedOrders);
        // setOrders(ordersArray);
        setPagination(orderResponse.data.data.orders);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false); // Hide loader after fetching data
      }
    };


    fetchOrders();
  }, [page, filter, refreshKey]);


  const handleShow = () => setShow(true);
  const handleShowEdit = (order) => {
    setOrder(order);
    setShowEdit(true);
  };
  const handleShowView = (order) => {
    setOrder(order);
    setShowView(true);
  };
  const handleClose = () => {
    setShow(false);
    setShowEdit(false);
    setShowView(false);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= pagination.last_page) {
      setPage(newPage);
    }
  };
  const handleRefresh = () => {
    setRefreshKey((prevRefreshKey) => prevRefreshKey + 1);
  };
  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const handleDelete = async (id) => {
    const result = await MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axiosInstance.post(`/user/order/delete/${id}`);
        handleRefresh();
        handleClose();
        toast.success("Order removed successfully!");
      } catch (error) {
        toast.error("Error deleting order:", error);
      }
    }
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          {apiSuccess && (
            <div className="alert alert-success alert-dismissible fade show" role="alert">
              <strong>Success!</strong> {apiSuccess}
              <button
                type="button"
                className="btn-close"
                onClick={() => setApiSuccess(null)}
                aria-label="Close"
              ></button>
            </div>
          )}
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0" style={{ color: "#c4281c" }}>
              Order Management
            </h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="/app">Dashboard</Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#c4281c" }}
                >
                  Order Management
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {loading && !filter ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "80vh" }}
        >
          <Oval
            height={80}
            width={80}
            color="#FF0200"
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#4fa94d"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      ) : (
        <div className="row" id="contactList">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header d-flex align-items-center border-0">
                <h5
                  className="card-title mb-0 flex-grow-1"
                  style={{ color: "#c4281b" }}
                >
                  Order Management
                </h5>
              </div>
              <div className="card-body border border-dashed border-end-0 border-start-0">
                <div className="d-flex justify-content-end">
                    {userTypeId === 8 || userTypeId === 3 || userTypeId === 2 || userTypeId === 1 ? (
                    <div className="col-xl-2 col-md-6">
                      <div>
                        <button
                          className="vehicle-button btn btn-primary"
                          style={{
                            backgroundColor: "#c4281b",
                            color: "#fff",
                            border: "none",
                          }}
                          onClick={handleShow}
                        >
                          <i className="mdi mdi-plus-circle-outline"></i>
                          Place Order
                        </button>
                      </div>
                    </div>
                  ) : null}

                </div>
                <br />
                <div className="col-xl-4 col-md-6">
                  <div className="search-box">
                    <input
                      type="text"
                      className="form-control search"
                      placeholder="Search to order..."
                      value={filter}
                      onChange={handleFilterChange}
                    />
                    <i className="ri-search-line search-icon"></i>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive table-card">
                  <table
                    className="table align-middle table-nowrap table table-striped table-borderless table-hover"
                    id="customerTable"
                  >
                    <thead className="table-light text-muted">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Company Name</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Total Price</th>
                        <th scope="col">Order Code</th>
                        <th scope="col">Sales Man</th>
                        <th scope="col">Date Added</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody className="list form-check-all">
                      {orders.length > 0 ? (
                        orders.map((order, index) => (
                          <tr key={order.id}>
                            <td>{index + 1}</td>
                            <td>
                              {order.company_name}
                            </td>
                            <td>{order.product_name}</td>
                            <td>{order.sum_quantity || order.quantity}</td>

                            <td>{order.sum_total_price || order.total_price}</td>
                            <td>{order.order_code}</td>
                            <td>{order.salesman}</td>
                            <td>{formatDate(order.created_at)}</td>
                            <td className="status">
                              {order.status === "approved" ? (
                                <span className="badge bg-success">Approved</span>
                              ) : order.status === "pending" ? (
                                <span className="badge bg-warning">Pending</span>
                              ) : order.status === "rejected" ? (
                                <span className="badge bg-danger">Rejected</span>
                              ) : (
                                <span className="badge bg-info">{order.status}</span>
                              )}
                            </td>

                            <td>
                              <div className="dropdown">
                                <button
                                  className="btn btn-icon btn-sm fs-16 text-muted dropdown"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="mdi mdi-apps"></i>
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      onClick={() => handleShowView(order)}
                                    >
                                      <i className="ri-eye-fill text-muted me-2 align-bottom"></i>
                                      View Order Info
                                    </Link>
                                  </li>
                                  {/* {userTypeId === 3 ? ( */}
                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      onClick={() => handleShowEdit(order)}
                                    >
                                      <i className="mdi mdi-pencil me-2 text-success"></i>{" "}
                                      Approve
                                    </Link>
                                  </li>
                                  {/* ) : null} */}

                                  <li>
                                    <Link
                                      className="dropdown-item"
                                      onClick={() => handleDelete(order.order_code)}
                                    >
                                      <i className="mdi mdi-trash-can-outline me-2 text-danger"></i>
                                      Delete Order
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No orders found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="d-flex mt-5 mb-5 flex-wrap">
                    <div className="pagination-wrap hstack gap-2 mx-auto">
                    <ul className="pagination">
                      <li
                        className={`page-item ${pagination.current_page === 1 ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            handlePageChange(pagination.current_page - 1)
                          }
                          disabled={pagination.current_page === 1}
                        >
                          Previous
                        </button>
                      </li>
                      {Array.from(
                        { length: pagination.last_page },
                        (_, index) => index + 1
                      ).map((pageNumber) => (
                        <li
                          key={pageNumber}
                          className={`page-item ${pageNumber === pagination.current_page
                            ? "active"
                            : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(pageNumber)}
                          >
                            {pageNumber}
                          </button>
                        </li>
                      ))}
                      <li
                        className={`page-item ${pagination.current_page === pagination.last_page
                          ? "disabled"
                          : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            handlePageChange(pagination.current_page + 1)
                          }
                          disabled={
                            pagination.current_page === pagination.last_page
                          }
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Modal components */}
      <CreateOrder
        show={show}
        closeModal={handleClose}
        refreshPage={handleRefresh}
        setParentSuccess={setApiSuccess}
      />
      <EditOrder
        showEdit={showEdit}
        closeModal={handleClose}
        order={order}
        refreshPage={handleRefresh}
      />
      <ViewOrder showView={showView}
        closeModal={handleClose}
        order={order} />
    </>
  );
}
